import { labelDefaultRegularStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const Requests = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['05']};
`

/** Each sibling request sits in its own bordered box so the repeated labels stay readable. */
export const Request = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['03']};
  border: 1px solid ${({ theme }) => theme.color.border.subtle as string};
  border-radius: ${({ theme }) => theme.size.border.radius['03']};
  padding: ${({ theme }) => theme.size.space['04']};
`

export const EmptyMessage = styled.p`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.secondary as string};
  margin: 0;
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['03']};
`
